import React, { useMemo, useState } from "react";
import {
  Card,
  CardBody,
  Container,
  Row,
  Col,
  Label,
  Form,
  Button,
  ModalFooter,
  ModalBody,
  ModalHeader,
  Modal,
} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import TableContainer from "../../components/Common/TableContainer";
import { post } from "../../helpers/api_helper";
import { REPORT_LIST } from "../../helpers/url_helper";
import { useForm, Controller } from "react-hook-form";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import toastr from "toastr";
import reportColumns from "components/Columns/ReportColumns";
import { PDFDownloadLink, PDFViewer } from '@react-pdf/renderer';
import MyReportPdf from './ReportPdf';

const DailyReport = () => {
  const [report, setReport] = useState([]);
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(false);
  const [isReportGenerated, setIsReportGenerated] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [showPdfModal, setShowPdfModal] = useState(false);

  const breadcrumbItems = [
    { title: "valfuel", link: "/" },
    { title: "Reports", link: "#" },
  ];

  const {
    handleSubmit,
    control,
  } = useForm({
    defaultValues: {
      customer_ul_id: [],
      date: new Date().toISOString().split("T")[0],
    },
  });

  const fetchReport = async (formData, userInitiated = false) => {
    try {
      setLoading(true);

      const localDate = new Date(formData.date);
      const yyyy = localDate.getFullYear();
      const mm = String(localDate.getMonth() + 1).padStart(2, "0");
      const dd = String(localDate.getDate()).padStart(2, "0");

      const selectedCustomer = (formData.customer_ul_id || [])
        .map((item) => item?.value)
        .filter(Boolean);

      const payload = {
        customer_ul_id: selectedCustomer,
        date: `${yyyy}-${mm}-${dd}`,
      };

      const response = await post(REPORT_LIST, payload);
      setReport(response.data || []);
      setTotalPages(response.data.totalPages || 0);

      if (userInitiated) {
        setIsReportGenerated(true);
      }
    } catch (error) {
      console.error("Failed to fetch report:", error);
      toastr.error("Failed to generate report.");
    } finally {
      setLoading(false);
    }
  };

  const handleSendPdf = (item) => {
    setSelectedCustomer(item);
    setShowPdfModal(true);
  };

  const columns = useMemo(() => reportColumns(handleSendPdf), [handleSendPdf]);


  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Pending order Report" breadcrumbItems={breadcrumbItems} />

          <Card>
            <CardBody>
              <Form onSubmit={handleSubmit((data) => fetchReport(data, true))}>
                <Row className="align-items-end">
                  <Col md={2}>
                    <Label>Date</Label>
                    <Controller
                      name="date"
                      control={control}
                      render={({ field }) => (
                        <Flatpickr
                          {...field}
                          className="form-control"
                          options={{
                            dateFormat: "Y-m-d",
                            maxDate: "today", // ⛔ disables future dates
                          }}
                        />
                      )}
                    />
                  </Col>
                  <Col md={2}>
                    <Button color="primary" type="submit" className="w-100">
                      Generate Report
                    </Button>
                  </Col>
                </Row>
              </Form>
            </CardBody>
          </Card>

          <Card>
            <CardBody>
              {loading ? (
                <div className="text-center">Loading...</div>
              ) : isReportGenerated ? (
                report.length > 0 ? (
                  <TableContainer
                    columns={columns}
                    data={report}
                    isPagination={true}
                    customPageSize={pageSize}
                    iscustomPageSize={false}
                    isBordered={false}
                    controlledPagination={{
                      pageIndex,
                      setPageIndex,
                      pageSize,
                      setPageSize,
                      totalPages,
                    }}
                  />
                ) : (
                  <div className="text-center text-danger">
                    <h4 className="py-5">No records found for the selected date.</h4>
                  </div>
                )
              ) : (
                <div className="text-center text-muted">
                  <h4>Please select a date and generate the report.</h4>
                </div>
              )}
            </CardBody>
          </Card>
          {isReportGenerated && report.length > 0 && (
            <div className="text-end mt-3">
              <PDFDownloadLink
                document={<MyReportPdf data={report} />}
                fileName="customer-report.pdf"
                className="btn btn-success"
              >
                {({ loading }) => (loading ? 'Preparing PDF...' : 'Download PDF')}
              </PDFDownloadLink>
            </div>
          )}
        </Container>
      </div>
      <Modal isOpen={showPdfModal} toggle={() => setShowPdfModal(false)} size="xl">
  <ModalHeader toggle={() => setShowPdfModal(false)}>
    Preview PDF for {selectedCustomer?.name}
  </ModalHeader>
  <ModalBody style={{ height: "80vh" }}>
    {selectedCustomer && (
      <PDFViewer width="100%" height="100%">
        <MyReportPdf data={[selectedCustomer]} />
      </PDFViewer>
    )}
  </ModalBody>
  <ModalFooter>
    {selectedCustomer && (
      <PDFDownloadLink
        document={<MyReportPdf data={[selectedCustomer]} />}
        fileName={`${selectedCustomer.name}-report.pdf`}
        className="btn btn-success"
      >
        {({ loading }) => (loading ? "Preparing..." : "Download PDF")}
      </PDFDownloadLink>
    )}
    <Button color="secondary" onClick={() => setShowPdfModal(false)}>
      Close
    </Button>
  </ModalFooter>
</Modal>

    </React.Fragment>

  );
};

export default DailyReport;
